exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".switch[data-v-10c6466d]{display:flex;align-items:center;gap:1rem;margin-left:1rem}", ""]);

